import { render, staticRenderFns } from "./AdminPreferenceView.vue?vue&type=template&id=02d3e273&scoped=true"
import script from "./AdminPreferenceView.vue?vue&type=script&lang=js"
export * from "./AdminPreferenceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3e273",
  null
  
)

export default component.exports